var _path, _rect, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 46,
    viewBox: "0 0 61 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.0234 37.7352C42.1455 38.4919 40.7778 38.0096 40.5686 36.8697L40.0768 34.1885C39.8688 33.0548 40.964 32.1199 42.051 32.5032L44.6076 33.4047C45.6946 33.7879 45.9612 35.203 45.0881 35.9555L43.0234 37.7352Z",
    fill: "#ECE9F8",
    stroke: "#8894AC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 49.8436,
    y: 3.58703,
    width: 6.80822,
    height: 31.2404,
    rx: 1.5,
    transform: "rotate(19.4225 49.8436 3.58703)",
    fill: "#ECE9F8",
    stroke: "#8894AC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8687 7.16278C56.1456 6.5037 56.9888 5.32363 58.5091 5.85968C60.0294 6.39573 60.014 7.90374 59.8163 8.59074L57.0104 16.5485",
    stroke: "#8894AC",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3927 5.23573L51.5353 4.22822C50.4936 3.86092 49.9306 2.66511 50.7228 1.8954C51.5037 1.13672 52.6727 0.623095 54.2462 1.17791C55.8427 1.74085 56.3994 2.89027 56.4919 3.97507C56.5838 5.05219 55.4122 5.59521 54.3927 5.23573Z",
    fill: "#FFD661",
    stroke: "#8894AC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.47192 42.9102C2.52513 43.6959 4.07092 44.8648 5.4792 44.6466C7.308 44.3631 8.38444 40.9791 8.78767 39.5768C9.32218 37.7179 9.78998 34.9821 9.12615 33.0816C8.70216 31.8677 7.21611 34.6863 7.12797 34.9037C6.45304 36.5685 6.13172 38.8836 6.75673 40.6165C7.63821 43.0605 10.5604 45.5098 12.4539 44.6466C14.4039 43.7576 15.5096 41.8929 15.7952 39.8662C15.8228 39.6699 15.7902 38.9385 15.8716 39.7376C15.9774 40.7758 16.056 42.4019 16.9089 43.1674C18.8855 44.9417 21.0878 39.5637 22.1937 40.5951C23.0712 41.4134 22.556 44.0465 24.5522 42.9316C26.238 41.9901 27.1198 40.4113 28.4394 39.1159C28.6741 38.8855 28.6583 39.736 28.7014 40.0592C28.8524 41.1909 28.9979 42.3952 29.5422 43.4247C30.4808 45.2 31.8919 43.6479 32.6978 42.653C33.1449 42.101 34.0996 39.8662 34.8816 40.9166C35.4745 41.713 36.7319 43.9289 38.0481 43.4461C39.3136 42.982 39.6638 41.125 40.0135 40.0377",
    stroke: "#8894AC",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignature);
export default __webpack_public_path__ + "static/media/signature.5edf069a9100bbd90bd863a7abe5094a.svg";
export { ForwardRef as ReactComponent };